export type Lang = "ar" | "en";
import { ar, en, Dict } from "./strings";

const dicts = { ar, en };
let lang: Lang = ((): Lang => {
  try {
    const s = localStorage.getItem("samra.lang");
    if (s === "ar" || s === "en") return s;
  } catch {}
  return navigator.language?.startsWith("en") ? "en" : "ar";
})();

export const getLang = () => lang;
export function setLang(l: Lang) {
  lang = l;
  try {
    localStorage.setItem("samra.lang", l);
  } catch {}
  applyDir();
}
export function applyDir() {
  document.documentElement.lang = lang;
  document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
}
export const t = new Proxy({} as Dict, { get: (_, k: string) => (dicts[lang] as any)[k] });

export function errText(e: any): string {
  const code = e?.code ?? e?.message;
  return (dicts[lang].errors as Record<string, string>)[code] ?? dicts[lang].genericError;
}

export const fmtSar = (halalas: number, currency = "SAR") =>
  new Intl.NumberFormat(lang === "ar" ? "ar-SA" : "en-SA", { style: "currency", currency }).format(halalas / 100);
export const fmtNum = (n: number) => new Intl.NumberFormat(lang === "ar" ? "ar-SA" : "en").format(n);
export const nameOf = (o: { name_ar?: string; name_en?: string }) => (lang === "ar" ? o.name_ar : o.name_en) ?? "";
